import React from "react";
import { useMessageContext } from "stream-chat-react";

// Replaces Stream's "N replies" link under a message with a pill showing the
// thread participants' avatars and the reply count. Rendered through
// Channel's MessageRepliesCountButton slot.
function ThreadSummaryButton({ onClick, reply_count: replyCount = 0 }) {
  const { message } = useMessageContext("ThreadSummaryButton");
  if (!replyCount) return null;

  const participants = (message?.thread_participants || []).slice(0, 3);
  const label = replyCount === 1 ? "1 reply" : `${replyCount} replies`;

  return (
    <button
      type="button"
      className="rw-thread-summary"
      onClick={onClick}
      aria-label={`Open thread, ${label}`}
    >
      {participants.length > 0 && (
        <span className="rw-thread-summary__avatars">
          {participants.map((user) => (
            <span
              className="rw-thread-summary__avatar"
              key={user.id}
              title={user.name}
            >
              {user.name?.trim()?.[0]?.toUpperCase() || "?"}
            </span>
          ))}
        </span>
      )}
      <span className="rw-thread-summary__label">{label}</span>
      <span className="rw-thread-summary__chevron" aria-hidden="true">›</span>
    </button>
  );
}

export default ThreadSummaryButton;
